import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        <div className="bg-white border-2 border-[#E5E5EA] rounded-3xl p-8 sm:p-12 text-center shadow-lg relative overflow-hidden" data-id="element-95">
          <div className="absolute top-0 left-0 w-full h-2 bg-[#00A650]" data-id="element-96" />

          <span className="text-6xl mb-6 block" data-id="element-97">🛡️</span>

          <h2 className="text-3xl sm:text-4xl font-black text-[#0A0A0A] mb-6 tracking-tight" data-id="element-98">
            Garantía de <span className="text-[#00A650]" data-id="element-99">7 Días</span>
          </h2>

          <p className="text-[#5A5A66] text-lg font-medium mb-6 max-w-lg mx-auto leading-relaxed" data-id="element-100">
            Si Fútbol Listo 360 no transforma completamente la forma en que
            planificas y diriges tus entrenamientos:
          </p>

          <p className="text-[#0A0A0A] text-xl sm:text-2xl font-black mb-4" data-id="element-101">
            Te devolvemos <br className="sm:hidden" data-id="element-102" />
            <span className="text-[#00A650]" data-id="element-103">el 100% de tu dinero.</span>
          </p>

          <p className="text-[#5A5A66] text-base font-bold mb-8 uppercase tracking-wider" data-id="element-104">
            Sin preguntas.
          </p>

          <span className="inline-block bg-[#FAFAFA] border border-[#E5E5EA] text-[#0A0A0A] text-xs font-black px-4 py-2 rounded-full uppercase tracking-wider" data-id="element-105">
            Tasa de reembolso inferior al 1%
          </span>
        </div>
      </div>
    </section>;
}